"use client";
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import panipuri from "./assets/Panipuri.jpg";

const MenuSection = () => {
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState("Chaat Time");
  const handleButtonClick = () => {
  navigate("/menu");
};

  const menuItems = [
    // Birthday cakes
    {
      id: 1,
      name: "Ferrero Rocher cake",
      price: "$ 55",
      category: "Birthday cakes",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/25dcaf6a2bf081582c9ef5c5a481ffd59d2a1873?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
    },
    {
      id: 2,
      name: "Gulab Jamun",
      price: "$ 55",
      category: "Birthday cakes",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/4adb096bd76cefc696df83fe65ddd2e55807617f?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
    },
    {
      id: 3,
      name: "Rasmalai cake",
      price: "$ 55",
      category: "Birthday cakes",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/0521e172f0a2ff8b9552c54495399396f65a81bf?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
    },
    {
      id: 4,
      name: "Butterscotch cake",
      price: "$ 55",
      category: "Birthday cakes",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/42b5056d7ceb59ab306ef48c2c5547e8dd9469a1?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
    },
    {
      id: 5,
      name: "Blueberry cake",
      price: "$ 50",
      category: "Birthday cakes",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/ad852224650ff8582f0129007c0faac403cbf3cc?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
    },
    {
      id: 6,
      name: "Strawberry cake",
      price: "$ 50",
      category: "Birthday cakes",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/5220aa1f7794af2c7fd6e9a2477a6b497815aa0b?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
    },
    {
      id: 7,
      name: "Mango Cake",
      price: "$ 55",
      category: "Birthday cakes",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/cd109b5cc6a47cc5c2c0a177bd1db84e3e34b765?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
    },
    {
      id: 8,
      name: "Pineapple cake",
      price: "$ 50",
      category: "Birthday cakes",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/c73660f810297122b585366f42db301d54e60c52?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
    },
    // Wedding cakes
    // {
    //   id: 9,
    //   name: "Royal Wedding Cake",
    //   price: "$ 150",
    //   category: "Wedding cakes",
    //   image: "https://cdn.acsdev.in/iynacakes/royal.jpg"
    // },
    // {
    //   id: 10,
    //   name: "Elegant Rose Cake",
    //   price: "$ 120",
    //   category: "Wedding cakes",
    //   image: "https://cdn.acsdev.in/iynacakes/rose.jpeg"
    // },
    {
      id: 11,
      name: "Classic Step Cake",
      price: "Contact us ",
      category: "Wedding cakes",
      image: "https://cdn.acsdev.in/iynacakes/step.jpeg"
    },
   /* {
      id: 12,
      name: "Vintage Lace Cake",
      price: "$ 180",
      category: "Wedding cakes",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/42b5056d7ceb59ab306ef48c2c5547e8dd9469a1?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
    },*/
    // Custom cakes
    {
      id: 13,
      name: "Superhero Theme",
      price: "$ 80",
      category: "Custom cakes",
      image: "https://cdn.acsdev.in/iynacakes/superhero.jpeg"
    },
    {
      id: 14,
      name: "Princess Castle",
      price: "$ 90",
      category: "Custom cakes",
      image: "https://cdn.acsdev.in/iynacakes/prince.jpeg"
    },
    {
      id: 15,
      name: "Sports Theme",
      price: "$ 75",
      category: "Custom cakes",
      image: "https://cdn.acsdev.in/iynacakes/sport.png"
    },
    
    {
      id: 17,
      name: "Pani puri(12)",
      price: "$7.99",
      category: "Chaat Time",
      image: panipuri
    },
    {
      id: 18,
      name: "Pani puri Unlimited",
      price: "$11.99",
      category: "Chaat Time",
      image:"https://cdn.acsdev.in/iynacakes/PanipuriUnlimited.jpg"
    },
    {
      id: 19,
      name: "Samosa chat",
      price: "$9.99",
      category: "Chaat Time",
      image:  "https://cdn.acsdev.in/iynacakes/Samosachat.jpg"
    },
    {
      id: 20,
      name: "Aloo-Chat",
      price: "$7.99",
      category: "Chaat Time",
      image: "https://cdn.acsdev.in/iynacakes/aloochat.jpg"
    },
    ,{
      id: 21,
      name: "Flower Cake",
      price: "Contact Store",
      category: "Custom cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/flower.jpeg"
    },{
      id: 22,
      name: "Gender Cake",
      price: "Contact Store",
      category: "Custom Cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/baby.jpeg"
    }
    ,{
      id: 23,
      name: "Mickey Mouse Cake",
      price: "Contact Store",
      category: "Custom cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/mickey.jpeg"
    },{
      id: 24,
      name: "Dog Cake",
      price: "Contact Store",
      category: "Custom cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/dog.jpeg"
    },{
      id: 25,
      name: "Jungle Cake",
      price: "Contact Store",
      category: "Custom cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/jungle.jpeg"
    }
    ,{
      id: 27,
      name: "Harry Potter",
      price: "Contact Store",
      category: "Custom cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/harrypoter.jpeg"
    },{
      id: 28,
      name: "All Animal Cake",
      price: "Contact Store",
      category: "Custom cakes",
      priceRange: "0-25",
      image: "https://cdn.acsdev.in/iynacakes/bigjungle.jpeg"
    }


  ];

  const filters = ["Chaat Time","Birthday cakes", "Wedding cakes", "Custom cakes"];

  const filteredItems = menuItems.filter(item => item.category === activeFilter);

  return (
    <motion.section
      className="flex overflow-hidden flex-col flex-1 items-center w-full bg-orange-100 px-4 md:px-8"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      aria-labelledby="menu-title"
    >
      {/* Section Divider - To change colors, modify the SVG fill="#currentColor" and stroke="#currentColor" properties in the image URL or replace with custom SVG */}
      <motion.img
        src="https://api.builder.io/api/v1/image/assets/TEMP/b70ed3145242d5de746760efaf735e368dd08f66?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
        alt="Decorative border"
        className="object-cover w-[120%] h-[140px] md:h-[60px] lg:h-[80px]"
        style={{ objectPosition: 'center' }}
        initial={{ scale: 0.8, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      />

      <motion.div
        className="flex flex-col mt-8 max-w-full w-[423px]"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        viewport={{ once: true }}
      >
        <h2
          id="menu-title"
          className="self-center text-4xl md:text-6xl font-semibold text-center text-cyan-900"
          style={{ fontFamily: "'Sansita Swashed', cursive" }}
        >
          Our Menu
        </h2>
        <div className="flex gap-6 items-center mt-6 justify-center">
          <img
            src="https://api.builder.io/api/v1/image/assets/TEMP/acbed261921e4571eafec62da8412aab268f0553?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
            alt="Decorative line left"
            className="object-contain shrink-0 self-stretch my-auto aspect-[83.33] w-[120px] md:w-[172px]"
          />
          <img
            src="https://api.builder.io/api/v1/image/assets/TEMP/bc8dd2f13700d84e651beef4acf3b42841019e71?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
            alt="Decorative center element"
            className="object-contain shrink-0 self-stretch my-auto aspect-square w-[25px] md:w-[35px]"
          />
          <img
            src="https://api.builder.io/api/v1/image/assets/TEMP/127b3226b78b80d6fe4792029f9fd682b664426b?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
            alt="Decorative line right"
            className="object-contain shrink-0 self-stretch my-auto aspect-[83.33] w-[120px] md:w-[172px]"
          />
        </div>
      </motion.div>

      <motion.div
        className="flex flex-wrap gap-2.5 items-start mt-8 max-w-full text-sm md:text-base text-red-500 min-h-11 justify-center"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4 }}
        viewport={{ once: true }}
        role="tablist"
        aria-label="Menu categories"
      >
        {filters.map((filter, index) => (
          <motion.button
            key={filter}
            className={`flex gap-1.5 justify-center items-center px-4 md:px-5 py-2 md:py-3 rounded-[32px] transition-all duration-300 whitespace-nowrap ${
              activeFilter === filter
                ? "text-white bg-red-500"
                : "border border-red-500 border-solid hover:bg-red-50"
            }`}
            onClick={() => setActiveFilter(filter)}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4, delay: 0.6 + index * 0.1 }}
            viewport={{ once: true }}
            role="tab"
            aria-selected={activeFilter === filter}
            aria-controls={`menu-panel-${filter.replace(/\s+/g, '-').toLowerCase()}`}
          >
            <span className="self-stretch my-auto">{filter}</span>
          </motion.button>
        ))}
      </motion.div>

      <motion.div
        className="mt-8 max-w-[1600PX] w-full max-w-6xl"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.8 }}
        viewport={{ once: true }}
      >
        <div className="overflow-hidden px-2.5 w-full">
          <AnimatePresence mode="wait">
            <motion.div
              key={activeFilter}
              className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.4 }}
              role="tabpanel"
              id={`menu-panel-${activeFilter.replace(/\s+/g, '-').toLowerCase()}`}
              aria-labelledby="menu-title"
            >
              {filteredItems.slice(0, 4).map((item, index) => (
                <motion.article
                  key={item.id}
                  className="flex overflow-hidden flex-col pb-6 md:pb-8 mx-auto w-full max-w-[280px] bg-white rounded-2xl border-[3px] border-slate-500"
                >
                  {/* IMAGE: zero letterbox, fills the whole area */}
                  <div className="relative aspect-square overflow-hidden rounded-t-xl">
                    <img
                      src={item.image}
                      alt={item.name}
                      loading="lazy"
                      className="absolute inset-0 w-full h-full object-cover object-center block"
                    />
                    <div className="absolute left-2 top-2 flex justify-center items-center px-2 bg-red-500 rounded-3xl h-[40px] w-[40px] md:h-[45px] md:w-[45px] text-xs text-white">
                      <span>SALE</span>
                    </div>
                  </div>

                  {/* TEXT */}
                  <div className="flex gap-3 md:gap-5 justify-between items-center self-center mt-4 md:mt-6 px-3 w-full">
                    <h3 className="text-lg md:text-xl leading-tight text-cyan-900 flex-1" style={{ fontFamily: "'Foolish Talk', cursive" }}>
                      {item.name}
                    </h3>
                    <span className="text-xl md:text-2xl font-semibold text-red-500 whitespace-nowrap">
                      {item.price}
                    </span>
                  </div>
                </motion.article>

              ))}
            </motion.div>
          </AnimatePresence>

          {filteredItems.length > 4 && (
            <motion.div
              className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mt-6 md:mt-9"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 1.2 }}
              viewport={{ once: true }}
            >
              {filteredItems.slice(4, 8).map((item, index) => (
                <motion.article
                  key={item.id}
                  className="flex overflow-hidden flex-col pb-6 md:pb-8 mx-auto w-full max-w-[280px] bg-white rounded-2xl border-[3px] border-slate-500"
                >
                  {/* IMAGE: zero letterbox, fills the whole area */}
                  <div className="relative aspect-square overflow-hidden rounded-t-xl">
                    <img
                      src={item.image}
                      alt={item.name}
                      loading="lazy"
                      className="absolute inset-0 w-full h-full object-cover object-center block"
                    />
                    <div className="absolute left-2 top-2 flex justify-center items-center px-2 bg-red-500 rounded-3xl h-[40px] w-[40px] md:h-[45px] md:w-[45px] text-xs text-white">
                      <span>SALE</span>
                    </div>
                  </div>

                  {/* TEXT */}
                  <div className="flex gap-3 md:gap-5 justify-between items-center self-center mt-4 md:mt-6 px-3 w-full">
                    <h3 className="text-lg md:text-xl leading-tight text-cyan-900 flex-1" style={{ fontFamily: "'Foolish Talk', cursive" }}>
                      {item.name}
                    </h3>
                    <span className="text-xl md:text-2xl font-semibold text-red-500 whitespace-nowrap">
                      {item.price}
                    </span>
                  </div>
                </motion.article>

              ))}
            </motion.div>
          )}
        </div>
      </motion.div>

      <motion.button
        className="flex gap-2 justify-center items-center px-6 md:px-8 py-3 md:py-4 mt-8 text-lg md:text-xl text-white bg-cyan-900 rounded-[42px] hover:bg-cyan-800 transition-colors duration-300"
        onClick={handleButtonClick}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 1.4 }}
        viewport={{ once: true }}
      >
        <span className="self-stretch my-auto">Explore More</span>
      </motion.button>

      {/* Section Divider with correct background color */}
      <motion.div
        className="mt-8 w-full flex justify-center"
        style={{ backgroundColor: '#ffedd5' }}
        initial={{ scale: 0.8, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.6, delay: 1.6 }}
        viewport={{ once: true }}
      >
        <img
          src="https://api.builder.io/api/v1/image/assets/TEMP/023c7e32def6b238884f943b06ac68d961fd306e?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
          alt="Section divider"
           
          className="object-cover w-full h-[40px] md:h-[60px] lg:h-[80px]"
          style={{ objectPosition: 'center',
            
           }}
        />
        
      </motion.div>
    </motion.section>
  );
};

export default MenuSection;
